<button
	#trigger
	type="button"
	class="pill"
	[class.has-value]="hasValue"
	[class.open]="open"
	[class.disabled]="disabled"
	[disabled]="disabled"
	aria-haspopup="true"
	[attr.aria-expanded]="open"
	(click)="togglePanel()">
	@if (hasValue) {
		<span class="chip">
			@if (mode === 'select' && selectedOption?.icon) {
				<lucide-icon [name]="selectedOption!.icon!" class="chip-icon"></lucide-icon>
			}
			<span class="chip-label">{{ mode === 'daterange' ? rangeLabel : (selectedOption?.label ?? '') }}</span>
			@if (clearable) {
				<button type="button" class="chip-clear" (click)="clearValue($event)" [attr.aria-label]="'actions.clear' | transloco">
					<lucide-icon name="X"></lucide-icon>
				</button>
			}
		</span>
	} @else {
		<span class="placeholder">{{ label }}</span>
	}
	<lucide-icon [name]="open ? 'ChevronUp' : 'ChevronDown'" class="chevron"></lucide-icon>
</button>

<ng-template #panel>
	<div class="pill-filter-panel" [class.daterange]="mode === 'daterange'" [ngClass]="panelClass">
		@if (mode === 'daterange') {
			<p-datepicker
				[inline]="true"
				selectionMode="range"
				[ngModel]="rangeDates"
				(ngModelChange)="onRangeChange($event)"
			></p-datepicker>
		}
		@for (option of options; track option.value) {
			<button
				type="button"
				class="option"
				[class.selected]="option.value === value"
				(click)="selectOption(option)">
				@if (option.icon) {
					<lucide-icon [name]="option.icon" class="option-icon"></lucide-icon>
				}
				<span class="option-label">{{ option.label }}</span>
				<span class="radio" [class.checked]="option.value === value">
					<span class="radio-dot"></span>
				</span>
			</button>
		}
	</div>
</ng-template>
